import { render, staticRenderFns } from "./BaseContentBox.vue?vue&type=template&id=1b618e60&scoped=true&"
import script from "./BaseContentBox.vue?vue&type=script&lang=js&"
export * from "./BaseContentBox.vue?vue&type=script&lang=js&"
import style0 from "./BaseContentBox.vue?vue&type=style&index=0&id=1b618e60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b618e60",
  null
  
)

export default component.exports